import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import importStore, { type ImportStoreState } from './importStore';

const devtoolsInstance = devtools(importStore, {
  name: 'useImportStore',
});

const useImportStore = create<ImportStoreState, [['zustand/devtools', never]]>(devtoolsInstance);

export default useImportStore;
